import { render } from "./CompanyInvoices.vue?vue&type=template&id=49e5c717&ts=true"
import script from "./CompanyInvoices.ts?vue&type=script&lang=ts"
export * from "./CompanyInvoices.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__